import { Cart } from 'cart';

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function mobileMenu() {
  const btn = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!btn || !menu) return;

  const close = () => {
    menu.dataset.open = 'false';
    menu.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  btn.addEventListener('click', () => {
    const open = menu.dataset.open === 'true';
    menu.dataset.open = open ? 'false' : 'true';
    menu.setAttribute('aria-hidden', open ? 'true' : 'false');
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    document.body.style.overflow = open ? '' : 'hidden';
  });
  menu.querySelectorAll('[data-menu-close]').forEach((el) => {
    el.addEventListener('click', close);
  });
  menu.querySelectorAll('a.mobile-menu__link[href]').forEach((link) => {
    link.addEventListener('click', close);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.dataset.open === 'true') close();
  });
}

function stickyATC() {
  const bar = document.querySelector('[data-sticky-atc]');
  const buy = document.querySelector('[data-main-add]');
  const stickyBtn = document.querySelector('[data-sticky-add]');
  if (!bar || !buy) return;
  const io = new IntersectionObserver(([entry]) => {
    bar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
    bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
  });
  io.observe(buy);
  stickyBtn?.addEventListener('click', () => buy.click());
}

function flyToCart(img, btn) {
  if (reduced() || !img) {
    btn?.click();
    return;
  }
  const cartBtn = document.querySelector('[data-cart-toggle]');
  if (!cartBtn) {
    btn?.click();
    return;
  }
  const clone = img.cloneNode(true);
  clone.className = 'fly-img';
  const rect = img.getBoundingClientRect();
  clone.style.width = `${rect.width}px`;
  clone.style.height = `${rect.height}px`;
  clone.style.left = `${rect.left}px`;
  clone.style.top = `${rect.top}px`;
  document.body.appendChild(clone);
  const target = cartBtn.getBoundingClientRect();
  requestAnimationFrame(() => {
    clone.style.transition = 'transform 400ms cubic-bezier(0.22,1,0.36,1), opacity 400ms';
    clone.style.transform = `translate(${target.left - rect.left}px, ${target.top - rect.top}px) scale(0.2)`;
    clone.style.opacity = '0.4';
  });
  setTimeout(() => {
    clone.remove();
    btn?.click();
  }, 420);
}

function contactForm() {
  const form = document.querySelector('.contact-form');
  const reasons = form?.querySelector('[data-contact-reasons]');
  if (!form || !reasons) return;

  const syncReasonState = () => {
    reasons.querySelectorAll('label.chip').forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      label.classList.toggle('is-selected', Boolean(input?.checked));
    });
  };

  reasons.addEventListener('change', syncReasonState);
  syncReasonState();

  form.addEventListener('submit', () => {
    const reason = reasons.querySelector('input[type="radio"]:checked')?.value;
    const body = form.querySelector('textarea[name="contact[body]"]');
    if (!reason || !body || body.dataset.reasonPrefixed === 'true') return;
    const trimmed = body.value.trim();
    body.value = trimmed ? `Reason: ${reason}\n\n${trimmed}` : `Reason: ${reason}`;
    body.dataset.reasonPrefixed = 'true';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mobileMenu();
  stickyATC();
  contactForm();
});

document.addEventListener('click', (e) => {
  const add = e.target.closest('[data-fly-add]');
  if (!add) return;
  e.preventDefault();
  const img = add.closest('form')?.querySelector('img') || document.querySelector('.pdp__media img, .pcard__media img');
  flyToCart(img, add);
});

export { mobileMenu, stickyATC, flyToCart, contactForm, Cart };
